import { z } from "zod";
export const RoadmapStatus = z.enum([
    "committed",
    "in_discovery",
    "in_execution",
    "blocked",
    "replanned",
    "completed",
    "abandoned",
    "deferred",
]);
const IsoDate = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "expected YYYY-MM-DD");
const IsoDateTime = z.string().datetime({ offset: true });
export const RoadmapEntryEnvelopeSchema = z.object({
    xi_entry_id: z.string().min(1),
    company_id: z.string().min(1),
    owner_user_id: z.string().min(1),
    title: z.string().min(1),
    intent: z.string().min(1),
    signal_lineage: z.record(z.string(), z.unknown()).default({}),
    status: RoadmapStatus,
    projected_outcome: z.record(z.string(), z.unknown()).default({}),
    target_window_start: IsoDate.optional(),
    target_window_end: IsoDate.optional(),
    promoted_at: IsoDateTime,
});
export const XiBusEventTypes = z.enum([
    "xi.roadmap.entry.promoted",
    "xi.roadmap.entry.updated",
    // Spotted Phase C: XI's analysis cycle reports back that a signal has
    // been ingested. Closes the reporter feedback loop — the originating
    // spot's outcome string is threaded from the signal's consumed_cycle.
    "xi.signal.consumed",
]);
/**
 * `xi.signal.consumed` envelope.
 *
 * XI fires this once per signal it incorporates into an analysis cycle.
 * `signal_id` is the row id PlayStudio handed to XI when the signal was
 * created. `cycle` is XI's own cycle identifier (e.g. "2026-10-28") that
 * we surface verbatim to the reporter on My Spotted.
 */
export const XiSignalConsumedEnvelopeSchema = z.object({
    signal_id: z.string().min(1),
    cycle: z.string().min(1),
    /** Optional one-line summary from XI for the spot detail page. */
    summary: z.string().max(500).optional(),
});
// Discriminated by `event_type`: roadmap events carry an `entry`, signal
// events carry a `signal_consumed` envelope. Either shape is accepted on
// the inbound bus.
export const XiBusEventSchema = z.union([
    z.object({
        xi_event_id: z.string().min(1),
        event_type: z.enum(["xi.roadmap.entry.promoted", "xi.roadmap.entry.updated"]),
        entry: RoadmapEntryEnvelopeSchema,
        emitted_at: IsoDateTime.optional(),
    }),
    z.object({
        xi_event_id: z.string().min(1),
        event_type: z.literal("xi.signal.consumed"),
        signal_consumed: XiSignalConsumedEnvelopeSchema,
        emitted_at: IsoDateTime.optional(),
    }),
]);
export const DeferRequestSchema = z.object({
    reason: z.string().min(1, "reason required"),
    deferred_until: IsoDate.optional(),
});
export const ReassignRequestSchema = z.object({
    new_owner_user_id: z.string().min(1),
    note: z.string().max(2000).optional(),
});
export const RequestContextSchema = z.object({
    question: z.string().min(1).max(2000),
});
